<plex-layout main="12">
    <plex-layout-main>
        <plex-title titulo="Reglas globales">
            <plex-button label="Volver" type="danger" position="left" routerLink="/solicitudes"></plex-button>
        </plex-title>
        <visualizacion-reglas [esParametrizado]="esParametrizado" [ocultarTitulo]="true">
        </visualizacion-reglas>
    </plex-layout-main>
</plex-layout>
